import userApi from '@/api/user'

const app = {
    state: {
        sidebar: {
            opened: !!localStorage.getItem('sidebarStatus'),
        },
        snackbar: {
            open: false,
            text: '',
            action: ''
        },
        loading: false,
        smLoading: false,
        dialog: {

        }
    },
    mutations: {
        TOGGLE_SIDEBAR: state => {
            if (state.sidebar.opened) {
                localStorage.setItem('sidebarStatus', 0)
            } else {
                localStorage.setItem('sidebarStatus', 1)
            }
            state.sidebar.opened = !state.sidebar.opened
        },
        SHOW_SNACKBAR: (state, {text, action}) => {
            state.snackbar.open = true
            state.snackbar.text = text
            state.snackbar.action = action
        },
        HIDE_SNACKBAR: (state) => {
            state.snackbar.open = false
            state.snackbar.text = ''
            state.snackbar.action = ''
        },
        SHOW_LOADING: (state) => {
            state.loading = true
        },
        HIDE_LOADING: (state) => {
            state.loading = false
        },
        SHOW_SM_LOADING: (state) => {
            state.smLoading = true
        },
        HIDE_SM_LOADING: (state) => {
            state.smLoading = false
        }
    },
    actions: {
        ToggleSideBar: ({commit}) => {
            commit('TOGGLE_SIDEBAR')
        },
        ShowSnackbar: ({commit}, {text = 'Unknown Error', timeout = 5000, action = ''}) => {
            commit('SHOW_SNACKBAR', {text, action})
            if (!!timeout) {
                setTimeout(() => {
                    commit('HIDE_SNACKBAR')
                }, timeout)
            }
        },
        HideSnackbar:({commit}) => {
            commit('HIDE_SNACKBAR')
        },
        ShowLoading({commit}) {
            commit('SHOW_LOADING')
        },
        HideLoading({commit}) {
            commit('HIDE_LOADING')
        },
        ShowSmLoading({commit}) {
            commit('SHOW_SM_LOADING')
        },
        HideSmLoading({commit}) {
            commit('HIDE_SM_LOADING')
        }
    }
}

export default app
